import { Injectable } from '@angular/core';
import { FrappeApp, FrappeDB } from 'frappe-js-sdk';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { AppConstant } from '../../app.constant';
import { Observable } from 'rxjs';
import { FilterAsnData, FilterSPoData } from '../../models/filter-shipment-data';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VendorTsService {

  private frappe: FrappeApp;
  private db: FrappeDB

  apiBaseUrl = environment.FRAPPE_API_URL

  constructor(private http: HttpClient) {
    this.frappe = new FrappeApp(AppConstant.frappeUrl);
    this.db = this.frappe.db()
  }

  public getVendorMasterList(status: string): Promise<any> {
    return this.frappe.call().get('vendor_portal.get_list.get_vendor_master_list', { status });
  }
  public getPageableVendorMasterList(data: any): Promise<any> {
    return this.frappe.call().get('vendor_portal.rest.get_all_pageable_vendor', { data });
  }
  public getVendorMList(): Promise<any> {
    return this.frappe.call().get('vendor_portal.get_list.get_vendor_list');
  }
  public get_change_request_history_list(): Promise<any> {
    return this.frappe.call().get('vendor_portal.rest.get_change_request_history_list');
  }
  public createVendorMaster(data: any): Promise<any> {
    return this.frappe.call().post('vendor_portal.rest.create_vendor_details', data);
  }
  public createBalckListVendor(data: any): Promise<any> {
    return this.frappe.call().post('vendor_portal.rest.create_black_list_vendor', { 'data': JSON.stringify(data) });
  }

  public createUser(data: any): Promise<any> {
    return this.frappe.call().post('vendor_portal.rest.add_vendor_details', data);
  }
  public uploadFile(url: string, file: File, args: any) {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);

    for (const [key, value] of Object.entries(args)) {
      if (typeof value === 'string' || value instanceof Blob) {
        formData.append(key, value);
      } else {

        formData.append(key, String(value));
      }
    }

    return this.http.post(url, formData);
  }

  public getVendorById(businessName: any): Promise<any> {
    return this.frappe.call().get('vendor_portal.get_list_by_id.get_vendor_master_list', { 'businessName': JSON.stringify(businessName) });
  }
  public getVendormasterChangeRequestById(status: any): Promise<any> {
    return this.frappe.call().get('vendor_portal.get_list_by_id.get_vendor_master_change_request_list', { 'status': JSON.stringify(status) });
  }
  public getVendorByIdForCR(vendor_code: any): Promise<any> {
    return this.frappe.call().get('vendor_portal.get_list_by_id.get_vendor_master_list_for_change_request', { 'vendor_code': JSON.stringify(vendor_code) });
  }
  public getVendorList(): Promise<any> {
    return this.frappe.call().get('vendor_portal.get_vendor_by_id.get_vendor_master_list');
  }
  public getVendorForSave(): Promise<any> {
    return this.frappe.call().get('vendor_portal.api.get_vendor_of_draft_status.get_vendor_details');
  }
  public getVendorForChangeDetail(): Promise<any> {
    return this.frappe.call().get('vendor_portal.api.change_detail.get_vendor_details_in_change_detail');
  }

  public checkIfVendor(): Promise<any> {
    return this.frappe.call().get('vendor_portal.rest.check_if_vendor');
  }

  public getShipmentASNList(data:any): Promise<any> {
    return this.frappe.call().get('vendor_portal.rest.get_shipment_orders',{ data });
  }
  public getExistingBatchNos(): Promise<string[]> {
    return this.frappe.call().get('vendor_portal.rest.get_all_batch_no')
  }
  downloadFile(fileUrl: string): Observable<Blob> {
    return this.http.get(fileUrl, {
      responseType: 'blob',
      headers: new HttpHeaders().append('Content-Type', 'application/octet-stream')
    });
  }

  public getShipmentfilterData(filterPoData: FilterSPoData, filterAsn: FilterAsnData): Promise<any> {
    return this.frappe.call().get('vendor_portal.rest.filter_shipment', { data: JSON.stringify(filterPoData), data2: JSON.stringify(filterAsn) });
  }

  public getGateAndPlantDetail(): Promise<any> {
    return this.frappe.call().get('vendor_portal.api.check_vendor_registration.get_gate_and_plant_details');
  }

  public approve_vendors(vendor: any): Promise<any> {
    return this.frappe.call().post('vendor_portal.rest.approve_vendors', { data: JSON.stringify(vendor) });
  }
  public reject_vendor(vendor: any): Promise<any> {
    return this.frappe.call().post('vendor_portal.rest.reject_vendors', { data: JSON.stringify(vendor) });
  }
  public approve_vendor_change_detail(businessName: string): Promise<any> {
    return this.frappe.call().post('vendor_portal.rest.approve_vendor_detail', { data: JSON.stringify(businessName) });
  }

  public reject_vendor_change_detail(businessName: string): Promise<any> {
    return this.frappe.call().post('vendor_portal.rest.reject_vendor_detail', { data: JSON.stringify(businessName) });
  }

  public create_vendor_query(data: any): Promise<any> {
    return this.frappe.call().post('vendor_portal.rest.create_vendor_query', { data: JSON.stringify(data) });
  }
  createOtherAddress(data: any, get_user: string): Promise<any> {
    return this.frappe.call().post('vendor_portal.rest.update_vendor_details', {
      data: data,
      get_user: get_user
    });
  }
  createVendorChangeRequest(data: any): Promise<any> {
    return this.frappe.call().post('vendor_portal.rest.create_vendor_change_detail', {
      data: JSON.stringify(data)
    });
  }

  createRole(data: any): Promise<any> {
    return this.frappe.call().post('vendor_portal.rest.create_role', {
      data: JSON.stringify(data)
    });
  }

  public getPaymentTerms(): Promise<any> {
    return this.frappe.call().get('vendor_portal.rest.get_paymen_terms')
  }
  public getCityAndState(): Promise<any> {
    return this.frappe.call().get('vendor_portal.rest.get_city_and_state_list')
  }

  public account_group_list(): Promise<any> {
    return this.frappe.call().get('vendor_portal.rest.account_group_list')
  }
  public getWithHoldingTaxCode(): Promise<any> {
    return this.frappe.call().get('vendor_portal.rest.get_all_with_holding_tax_code')
  }
  public getWithHoldingTaxType(): Promise<any> {
    return this.frappe.call().get('vendor_portal.rest.get_all_with_holding_tax_type')
  }
  public ReconciliationType(): Promise<any> {
    return this.frappe.call().get('vendor_portal.rest.get_reconciliation_type')
  }
  public VendorPayableAccounts(): Promise<any> {
    return this.frappe.call().get('vendor_portal.rest.get_vendor_payable_accounts')
  }
  public getVendorMenuList(): Promise<any> {
    return this.frappe.call().get('vendor_portal.rest.get_vendor_menu')
  }

  search_by_email_vm_contact_detail(email: string): Observable<any> {
    const url = `${this.apiBaseUrl}/api/method/vendor_portal.api.check_vendor_registration.search_by_email_vm_contact_detail`;
    const params = { params: { data: email } };
    return this.http.get(url, params);
  }
  search_by_contact_detail(type: 'email_id' | 'telephone' | 'mobile_phone', data: string): Observable<any> {
    const url = `${this.apiBaseUrl}/api/method/vendor_portal.api.check_vendor_registration.search_by_contact_detail`;
    const params = new HttpParams().set('data', data).set('type', type);
    return this.http.get(url, { params });
  }

  search_by_ifsc_code(ifsc: string): Observable<any> {
    const url = `${this.apiBaseUrl}/api/method/vendor_portal.rest.search_by_ifsc_code`;
    const params = { params: { data: ifsc } };
    return this.http.get(url, params);
  }

  public getRoleList(): Promise<any> {
    return this.frappe.call().get('vendor_portal.rest.get_role_list');
  }
  public getVendorQueryList(): Promise<any> {
    return this.frappe.call().get('vendor_portal.rest.get_all_vendor_query');
  }
  public downloadVendorByDate(data:any): Promise<any> {
    return this.frappe.call().get('vendor_portal.rest.download_vendor_by_date',{data:JSON.stringify(data)})
  }
}



